import React, { useEffect, useState } from 'react';
import './AdminDash.css'

function AdminDash() {

  const [data , setData] = useState('')
  console.log(data.length);
  


useEffect(()=>{
  async function featchUser(){
    try {
      const response = await fetch('https://us-central1-fabdiz-quote.cloudfunctions.net/api/Users');
      if(!response.ok){
        throw new Error('failed to fetch users');
      }
      const data = await response.json();
      setData(data);
    } catch (error) {
      console.log(error.message); 
    }
  }
  featchUser();
},[])



  return (
    <div className='rerer' >
      <div className='adminHeader' >
        <h2> Admin Dashboard</h2>
      </div>
      <div className='adminHeader1' >
        <h2>Dashboard</h2>
      </div>
      <hr/>
      <div className='adminHeader2'>
        <div className='Cards' >
          <div>
            <h4>Totle Projects</h4>
          </div>
          <hr />
          <div>
            <h4>123</h4>
          </div>
        </div>
        <div className='Cards' >
          <div>
            <h4>Outgoing Projects</h4>
          </div>
          <hr />
          <div>
            <h4>123</h4>
          </div>
        </div>
        <div className='Cards' >
          <div>
            <h4>Completed Projects</h4>
          </div>
          <hr />
          <div>
            <h4>123</h4>
          </div>
        </div>
        <div className='Cards' >
          <div>
            <h4>Junk Project</h4>
          </div>
          <hr />
          <div>
            <h4>123</h4>
          </div>
        </div>

      </div>
      <hr/>
      <div>

      </div>
    </div>
  );
}

export default AdminDash;
